<template>
  <div class="part-card">
    <v-hover v-slot:default="{ hover }">
      <v-card
        :elevation="hover ? 6 : 2"
        class="mx-1"
        @click="$emit('part:click', part)"
      >
        <v-container class="py-0">
          <v-row justify="space-between">
            <v-col cols="auto" class="d-flex align-center">
              <v-img
                :src="'/img/placeholder_item_1.png'"
                max-width="50px"
                max-height="50px"
              />
            </v-col>

            <v-col offset="1">
              <v-row>
                <v-col>
                  <span>
                    {{ part.clientPartNo }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-light">
                    {{ part.material }} - {{ part.finish }}
                  </span>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <v-btn
                small
                color="grey"
                icon
                @click=""
              >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: 'PartCard',

  props: {
    part: {}
  },
};
</script>

<style scoped>

</style>
